import Icon from '../components/Icon.vue'

Icon.register({
  'minus-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM92 296h264c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12h-264c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/minus-square.js
// module id = 1570
// module chunks = 0